// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__2irKQ","inputHolder":"input_inputHolder__2oX5h","err":"input_err__7SURd"};